"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpPluginDazn_1 = require("../../Http/HttpPluginDazn");
function createHttpPlugin(shaka, httpMonitor) {
    var xhrFactory = function () {
        return new XMLHttpRequest();
    };
    var httpPlugin = new HttpPluginDazn_1.default(shaka, xhrFactory, httpMonitor);
    return httpPlugin;
}
exports.default = createHttpPlugin;
//# sourceMappingURL=createHttpPlugin.js.map